<template>
        <div
          v-if="a.requiredCardsBlock4.length && a.hasPermission('edit projects')"
          class="required-block required-block-4 mb-1"
        >
          <b-button
            variant="link"
            @click="a.checkThemAll(4)"
          >
            <h6 class="required-block-title mb-1">
              <feather-icon
                :icon="a.show_attachments_block4 ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                size="16"
                class="mr-1"
              />
              ملفات الرفع علي المنصة
            </h6>
          </b-button>
          <b-collapse v-model="a.show_attachments_block4">

            <team-editor-card type="uploadOnPlatform" />

            <div class="d-flex flex-wrap required-block-cards">
              <attachment-media-card
                v-for="card in a.requiredCardsBlock4"
                :key="`required-${card.key}`"
                :title="card.key"
                :file="card.file"
                :upload-value="a.requiredUploads[card.key]"
                upload-layout="inline"
                  :show-team-disabled-message="a.isUploadDisabledByTeam(card.key)"
                  :accept="a.getAcceptExtensions(card.key)"
                :upload-disabled="a.isUploadDisabledByTeam(card.key)"
                :uploading="a.isUploadingRequired(card.key)"
                :is-cad-ark="card.key === 'ملف CAD من الارك'"
                card-margin-class="mb-2"
                notes-section-class=""
                notes-textarea-class="mb-1"
                :show-collection-checkbox="a.isProject168 && Boolean(card.file)"
                :collection-selected="Boolean(card.file && a.isCollectionSelected(card.file))"
                :editing-note="a.isFileNoteEditing(card.file)"
                :note-draft="a.getFileNoteDraft(card.file)"
                :saving-note="a.isFileNoteSaving(card.file)"
                @update:upload-value="a.setRequiredUpload(card.key, $event)"
                @submit-upload="a.submitRequired(card.key)"
                @delete="a.deleteFile(card.file.id)"
                @save-note="a.saveNote(card.file)"
                @cancel-edit-note="a.cancelEditingNote(card.file.id)"
                @start-edit-note="a.startEditingNote(card.file)"
                @update:note-draft="a.setFileNoteDraft(card.file, $event)"
                @collection-change="a.onCollectionCheckboxChange(card.file, $event)"
              />

            </div>
            <ProjectNoteEditor
              :project-id="a.projectId"
              group="attachments_block4"
              label="ملاحظات ملفات الرفع على المنصة"
              class="mb-2"
            />
          </b-collapse> 
        </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'

export default {
  name: 'AttachmentsBlock4',
  mixins: [attachmentsBlockMixin],
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
